/**
 * storage的处理
 */

const DEFAULT_STORAGE_KEY = `music${window.location.origin.replace(
  /^(https?:\/\/)(.*)(\.com)$/g,
  (m, $1, $2) => $2
)}${window.location.pathname}`;

/**
 * 设置属性
 * @param name
 * @param value
 * @param time
 * @param defaultStorageKey
 * @returns
 */
const set = (
  name: string,
  value: any,
  time = 0,
  defaultStorageKey = DEFAULT_STORAGE_KEY
) => {
  if (!name) return;
  const storage = {
    createdTime: new Date().getTime(),
    cacheTime: time * 1000,
    data: value,
  };
  window.localStorage.setItem(
    `${name}${defaultStorageKey}`,
    JSON.stringify(storage)
  );
};
/**
 * 清除属性
 * @param name
 * @param defaultStorageKey
 * @returns
 */
const clear = (name: string, defaultStorageKey = DEFAULT_STORAGE_KEY) => {
  if (!name) return;
  window.localStorage.removeItem(`${name}${defaultStorageKey}`);
};

/**获取属性 */
const get = (name: string, defaultStorageKey = DEFAULT_STORAGE_KEY) => {
  if (!name) return;
  const storageStr = window.localStorage.getItem(`${name}${defaultStorageKey}`);
  try {
    const storage = JSON.parse(storageStr as any);
    if (!storage) return;
    if (
      storage.cacheTime &&
      new Date().getTime() - storage.createdTime > storage.cacheTime
    ) {
      clear(`${name}${defaultStorageKey}`);
      return;
    }
    return storage.data;
  } catch (e) {
    if (typeof storageStr === "string") {
      return storageStr;
    }
  }
};

export default {
  set,
  get,
  clear,
};
